import { useState, useEffect, useMemo } from "react";

import styled from "styled-components";

import { ImArrowLeft, ImArrowRight } from "react-icons/im";


const Div = styled.div`
  width: 98%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  border-radius: 0px 0px 15px 15px;
`;

const Table = styled.table`
  width: 98%;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 0.5px;
  margin: 1%;

`;

const Input = styled.input`
  width: 345px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  margin: 10px 0px 0px 30px;

`;

const Thead = styled.thead``;

const Tbody = styled.tbody`
  padding-bottom: 25px; 
`;

const Tr = styled.tr`
  text-align: center;
  &:hover {
    color: black;
    background-color: #f5f5f5;
  }

`;

const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;


`;
const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0px;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    word-break: none;
    text-align: center;
  }
 

`;




const Grid = ({ acessoPagina }) => {



  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(acessoPagina);
  const [isLoading, setIsLoading] = useState(true);

  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = acessoPagina.filter((user) => {
        const pagina = (user.DESC_PAGINA || '').toLowerCase();
        const modulo = (user.DESC_MODULO || '').toLowerCase();


        return (
          pagina.includes(term.toLowerCase()) ||
          modulo.includes(term.toLowerCase())
        );
      });
      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }
    setCurrentPage(1);
    setIsLoading(false);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, acessoPagina]);


  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };

  return (

    <Div>
      <Td3>
        <Input
          type="text"
          placeholder="Pesquisar... Ex:módulo ou página"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div>
          <Button onClick={handlePrevPage} disabled={currentPage === 1}>
            <ImArrowLeft size={20} />
          </Button>
          <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ImArrowRight size={20} />
          </Button>
        </div>
      </Td3>

      {/* Tabela */}
      <Table>
        <Thead>
          <Tr>
            <Th onClick={() => onColumnClick("DESC_MODULO")} className={getSortClass("DESC_MODULO")}>
              Módulo: {getSortIcon("DESC_MODULO")}
            </Th>
            <Th onClick={() => onColumnClick("DESC_PAGINA")} className={getSortClass("DESC_PAGINA")}>
              Página: {getSortIcon("DESC_PAGINA")}
            </Th>
            <Th onClick={() => onColumnClick("TOTAL_ACESSOS")} className={getSortClass("TOTAL_ACESSOS")}>
              Data do acessos: {getSortIcon("TOTAL_ACESSOS")}
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.map((item, i) => (
            <Tr key={i} >
              <Td width="auto">{item.DESC_MODULO}</Td>
              <Td width="auto">{item.DESC_PAGINA}</Td>
              <Td width="auto">{item.TOTAL_ACESSOS}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Div>
  );
};


export default Grid;



